import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ImpersonationChangedModal, type ImpersonationChangedModalProps,
} from './ImpersonationChangedModal';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ImpersonationChanged: ImpersonationChangedModalProps;
  }
}

modalRenderer.register('ImpersonationChanged', ImpersonationChangedModal);
